import { ActivatedRouteSnapshot } from '@angular/router';
import { resolveModernFramePagePath } from '@platform/contracts';

function findDeepestSnapshot(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let current = route;
  while (current.firstChild) current = current.firstChild;
  return current;
}

function collectRouteSegments(route: ActivatedRouteSnapshot): readonly string[] {
  const segments: string[] = [];
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    segments.push(...current.url.map((segment) => segment.path));
    current = current.firstChild;
  }
  return segments;
}

export function resolvePagePath(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = findDeepestSnapshot(route);

  while (current) {
    const pagePath = current.data?.['pagePath'];
    if (typeof pagePath === 'string' && pagePath.trim() !== '') return pagePath.trim();
    current = current.parent;
  }

  const segments = collectRouteSegments(route);
  return segments.length > 0 ? resolveModernFramePagePath('/' + segments.join('/')) : null;
}
